import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c213f4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Posición"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "P"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "PV"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "PD"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "+-"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "G")
  ])
], -1))
const _hoisted_2 = { class: "jugador-cell" }
const _hoisted_3 = { class: "jugador-contenido" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esperando resultados...", -1))
const _hoisted_6 = [
  _hoisted_5
]

import { Clasificacion } from "@/interfaces/Live";



export default /*#__PURE__*/_defineComponent({
  __name: 'TablaClasificacionIndividual',
  props: {
    clasificacion: {}
  },
  emits: ["click-ejercito"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_ctx.clasificacion.length > 0)
    ? (_openBlock(), _createBlock(_component_v_table, {
        key: 0,
        density: "compact"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clasificacion, (jugador, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: jugador.nick,
                class: _normalizeClass({
          'good-bando': jugador.bando === 'good',
          'evil-bando': jugador.bando === 'evil',
        })
              }, [
                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(jugador.nick) + " ", 1),
                    _createVNode(_component_v_chip, {
                      class: "ml-2",
                      color: "grey-lighten-2",
                      "text-color": "black",
                      label: "",
                      size: "small",
                      variant: "tonal",
                      onClick: ($event: any) => (_ctx.$emit('click-ejercito', jugador))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(jugador.nombreCortoEjercito), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(jugador.puntosTorneo), 1),
                _createElementVNode("td", null, _toDisplayString(jugador.puntosFavor), 1),
                _createElementVNode("td", null, _toDisplayString(jugador.puntosContra), 1),
                _createElementVNode("td", null, _toDisplayString(jugador.diferenciaPuntos), 1),
                _createElementVNode("td", null, _toDisplayString(jugador.lider), 1)
              ], 2))
            }), 128))
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
}
}

})